import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Icon, Grid, Input, Form } from "semantic-ui-react";

import {
  StyledGridRow,
  StyledSelect,
  StyledCheckBox,
  ZebraList,
  FormErrorLabel,
  StyledModal,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
} from "../common/StyledComponents";

import { BranchOptions, RoleOptions, StatusOptions, GenderOptions } from "../common/constants";
import { convertArraytoSelectOptionsList } from "../common/helpers";
import { isValidName, isValidEmail } from "../common/validations";

const AddOrEditModal = (props) => {
  let modalData = {
    active: false,
    admin: false,
    branches: [],
    dateOfBirth: null,
    emailAddress: null,
    firstName: null,
    gender: "M", // TODO -
    lastName: null,
    newUser: true,
    orgId: null,
    password: null,
    phoneNumber: null,
    roles: [],
  };

  if (props.userData) {
    modalData = { ...modalData, ...props.userData };
  }

  const [userInfo, setUserInfo] = React.useState(modalData);
  const [open, setOpen] = React.useState(props.openState);
  const [selectAll, setSelectAll] = React.useState(false);

  const _roleOptions = convertArraytoSelectOptionsList(
    [...new Set(RoleOptions)],
    "role"
  );
  const _activeList = convertArraytoSelectOptionsList(
    [...new Set(StatusOptions)],
    "status"
  );
  const _genderList = convertArraytoSelectOptionsList(
    [...new Set(GenderOptions)],
    "gender"
  );

  const checkIfEmailExist = (email) => {
    return props.users.some((u) => u.emailAddress === email);
  };

  const [errors, setErrors] = useState({});

  const closeModal = () => {
    setOpen(false);
    props.closeModal();
  };

  const setDefaultCheckedLocations = (name, _branches = []) => {
    return _branches?.includes(name);
  };

  const onChangeForm = (e) => {
    const { name, value } = e.target;
    let _userInfo = {};
    if (name === "admin") {
      _userInfo.admin = e.target.checked;
    } else {
      _userInfo[name] = value;
    }
    if (name === "firstName" || name === "lastName") {
      if (!isValidName(value)) {
        errors[name] = "Please enter valid name";
      } else {
        delete errors[name];
      }
      setErrors(errors);
    }
    if (name === "emailAddress") {
      if (!isValidEmail(value)) {
        errors[name] = "Please enter valid email";
        // setErrors(errors);
      } else if (!props.isEditMode && checkIfEmailExist(value)) {
        errors[name] =
          "This email already exist in our system. Please enter a different email address.";
        // setErrors(errors);

        // setErrors(errors);
      } else {
        delete errors[name];
      }
      setErrors(errors);
    }
    const _finalData = { ...userInfo, ..._userInfo };
    setUserInfo(_finalData);
  };

  const onChangeActiveUser = (e) => {
    const { innerText } = e.currentTarget;
    let _userInfo = {};
    userInfo.active = innerText === "Active";
    const _finalData = { ...userInfo, ..._userInfo };
    setUserInfo(_finalData);
  };
  const onChangeGender = (e) => {
    const { innerText } = e.currentTarget;
    let _userInfo = {};
    userInfo.gender = innerText;
    const _finalData = { ...userInfo, ..._userInfo };
    setUserInfo(_finalData);
  };

  const onChangeRole = (e) => {
    const { innerText } = e.currentTarget;
    let _userInfo = {};
    userInfo.roles = [innerText];
    const _finalData = { ...userInfo, ..._userInfo };
    setUserInfo(_finalData);
  };

  const onSaveUser = () => {
    if (Object.keys(errors).length === 0) {
      let _userInfo = userInfo;
      if (props.isEditMode) {
        _userInfo = { ...userInfo, newUser: false };
      }
      props.onSaveUser(_userInfo, props.isEditMode);
    }
  };

  const selectAllBranches = (e) => {
    let _userInfo = {};
    let _branch = { branches: [] };
    if (e.target.checked) {
      _branch.branches = BranchOptions;
    }
    setSelectAll(e.target.checked);
    _userInfo = { ...userInfo, ..._branch };
    setUserInfo(_userInfo);
  };

  const setBranches = (e) => {
    let _branches = userInfo.branches || [];
    if (e.target.checked && !_branches.includes(e.target.value)) {
      _branches.push(e.target.value);
    } else {
      _branches = _branches.filter((b) => b !== e.target.value);
    }
    setUserInfo({ ...userInfo, branches: _branches });
  };

  return (
    <StyledModal
      onClose={() => closeModal()}
      onOpen={() => setOpen(true)}
      open={open}
    >
      <ModalContent>
        <ModalHeader>
          <span aria-hidden="false" />
          <h2>
            {props.isEditMode
              ? userInfo.firstName + " " + userInfo.lastName
              : "Add New User"}
          </h2>
          <Icon name="times" role="button" onClick={closeModal}></Icon>
        </ModalHeader>
        <ModalBody>
          <Form style={{ width: "100%" }}>
            <Form.Group>
              <Form.Input
                id="form-input-first-name"
                name="firstName"
                error={errors.firstName}
                label="First name"
                placeholder="First name"
                defaultValue={userInfo.firstName}
                onChange={(e) => onChangeForm(e)}
                width={6}
              />
              <Form.Input
                id="middleName"
                name="middleName"
                label="Middle name"
                placeholder="Middle name"
                onChange={(e) => onChangeForm(e)}
                width={4}
              />
              <Form.Input
                id="lastName"
                name="lastName"
                error={errors.lastName}
                label="Last name"
                placeholder="Last name"
                defaultValue={userInfo.lastName}
                onChange={(e) => onChangeForm(e)}
                width={6}
              />
            </Form.Group>
            <Form.Group>
              <Form.Input
                label="Email address"
                type="email"
                placeholder="Email address"
                size="small"
                id="emailAddress"
                name="emailAddress"
                error={errors.emailAddress}
                defaultValue={userInfo.emailAddress}
                onChange={(e) => onChangeForm(e)}
                width={6}
              />

              <Form.Field
                control={StyledSelect}
                fluid
                icon="angle down"
                id="roles"
                name="roles"
                error={errors.role}
                placeholder="Role"
                label="Role:"
                options={_roleOptions}
                defaultValue={userInfo.roles.length && userInfo.roles[0]}
                onChange={(e) => onChangeRole(e)}
                width={6}
              />
              <Form.Field
                control={StyledSelect}
                fluid
                icon="angle down"
                id="active"
                name="active"
                placeholder="Status"
                label="Status:"
                error={errors.status}
                options={_activeList}
                defaultValue={userInfo.active ? "Active" : "Inactive"}
                onChange={(e) => onChangeActiveUser(e)}
                width={4}
              />
              <Form.Field
                control={StyledSelect}
                fluid
                icon="angle down"
                id="gender"
                name="gender"
                placeholder="Gender"
                label="Gender:"
                error={errors.status}
                options={_genderList}
                defaultValue={userInfo.gender}
                onChange={(e) => onChangeGender(e)}
                width={4}
              />
            </Form.Group>
            <Form.Group>
              <Form.Input
                label="Phone number:"
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                placeholder="Phone number"
                defaultValue={userInfo.phoneNumber}
                error={errors.phone}
                onChange={(e) => onChangeForm(e)}
                width={6}
              />
              {!props.isEditMode && (
                <Form.Input
                  label="Password:"
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Enter password"
                  error={errors.password}
                  onChange={(e) => onChangeForm(e)}
                  width={6}
                />
              )}

              <Form.Checkbox
                label="Admin Access"
                name="admin"
                id="admin"
                defaultChecked={userInfo.admin}
                onChange={(e) => onChangeForm(e)}
                width={4}
              />
            </Form.Group>
            <StyledGridRow>
              <Grid.Column width={16}>
                <p>Assign to branches:</p>
                {errors.branch && (
                  <label className="error">Assign to branches:</label>
                )}
              </Grid.Column>
              <Grid.Column width={16} verticalAlign="bottom">
                <ZebraList>
                  <li>
                    <StyledCheckBox
                      label="Branches"
                      name="AllBranches"
                      id="AllBranches"
                      onChange={(e) => selectAllBranches(e)}
                    />
                  </li>
                  {selectAll &&
                    BranchOptions?.map((branch) => {
                      return (
                        <li key={branch}>
                          <StyledCheckBox
                            label={branch}
                            name={branch}
                            id={branch}
                            value={branch}
                            checked
                            onChange={(e) => setBranches(e)}
                          />
                        </li>
                      );
                    })}
                  {!selectAll &&
                    BranchOptions?.map((branch) => {
                      return (
                        <li key={branch}>
                          <StyledCheckBox
                            label={branch}
                            name={branch}
                            id={branch}
                            value={branch}
                            defaultChecked={setDefaultCheckedLocations(
                              branch,
                              userInfo.branches
                            )}
                            onChange={(e) => setBranches(e)}
                          />
                        </li>
                      );
                    })}
                </ZebraList>
              </Grid.Column>
            </StyledGridRow>
          </Form>
        </ModalBody>
      </ModalContent>
      <ModalFooter>
        {props.isEditMode && <Button basic>Delete User</Button>}
        <Button basic onClick={() => closeModal()}>
          Cancel
        </Button>
        <Button primary onClick={() => onSaveUser()}>
          Save
        </Button>
      </ModalFooter>
    </StyledModal>
  );
};

AddOrEditModal.propTypes = {};

AddOrEditModal.defaultProps = {
  isEditMode: false,
};

export default React.memo(AddOrEditModal);
